import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { FavoriteIcon, OutlineFavoriteIcon } from 'elc-icons';
import { classes } from '../../utils/Classes';
import { FavoritesState } from '../../constants/Features';

export interface IFavoritesIconProps {
    isFavorite: boolean;
}

const StyledIcon = styled.div`
    padding: ${ContentSpacing.space8};
`;

export const FavoritesIcon = observer((props: IFavoritesIconProps) => {
    const { isFavorite } = props;
    const iconClass = classes(
        `favorite-button-icon-${isFavorite ? FavoritesState.ON : FavoritesState.OFF}`
    );
    const icon = isFavorite ? <FavoriteIcon /> : <OutlineFavoriteIcon />;

    return <StyledIcon className={iconClass}>{icon}</StyledIcon>;
});
